module.exports = __webpack_public_path__ + "img/luoxuanta1.86ac173a.jpg";